module.exports = __webpack_public_path__ + "media/pharmacogenetic_animation.064cc27e.mp4";